import { Vue2K18nNext } from '@k18n/vue2-k18n-next';
import Vue from 'vue';

var commonLangs = require('@k18n/kibt-fe-creator-language/tags/common/index.json'); // const k18n :any = new Vue2K18nNext({messages:[commonLangs]});


Vue.use(Vue2K18nNext, {
  messages: [commonLangs]
});